export const GLOBAL = {
  languages: {
    'pt-br': {
      nav: {
        work: 'Projetos',
        about: 'Quem sou',
        contact: 'Contato',
      },
      mainTitle:
        'Criando interfaces modernas, responsivas, acessivas, focadas na melhor experiência do usuário.',
      imageDescriptionLeft:
        'Fundo com imagem do rosto de Julio Graffin usando óculos de grau.',
      imageDescriptionRight: 'Fundo com a imagem de um código-fonte genérico.',
      headingProjects:
        'Layouts institucionais, landing pages, hotsites, apps híbridos e portais digitais. Atuação em diferentes cenários e equipes, onde desenvolvi uma visão <strong>focada em evolução contínua</strong>.',
      descriptionProjects:
        '<strong>Com mais de 15 anos de experiência</strong> atuando em diversas empresas de tecnologia no mundo possuo sólido conhecimento, com foco em usabilidade, acessibilidade e desenvolvimento de produtos digitais de alta qualidade.',
      seeMore: 'ver mais',
      seeProject: 'ver projeto',
      send: 'enviar',
      sending: 'Enviando...',
      form: {
        name: 'Nome',
        email: 'E-mail',
        message: 'Mensagem',
        required: '(Obrigatório)',
        placeholder: 'Escreva sua mensagem aqui...',
        contactForm: 'Formulário de contato',
        contactChannels: 'Canais de atendimento e Redes Sociais',
        errorName: 'Informe seu nome completo.',
        errorEmail: 'Informe um e-mail válido.',
        errorMessage: 'A mensagem deve ter ao menos 10 caracteres.',
        successMessage:
          'Mensagem enviada com sucesso! Entrarei em contato em breve.',
        errorSend: 'Não foi possível enviar. Tente novamente.',
      },
      about: {
        pageTitle: 'Julio Cezar Ferreira',
        pageSubtitle: 'Analista Desenvolvedor Frontend Sr.',
        whoIAmTitle: 'Quem Sou',
        whoIAmP1:
          'Com uma trajetória sólida no universo da tecnologia desde 2010, minha carreira é marcada pela união entre o <strong>design visual</strong> e a <strong>precisão do código</strong>.',
        whoIAmP2:
          'Comecei minha jornada como <strong>Web Designer</strong> na agência <strong>Refinaria Ilimitada</strong>, onde criei layouts institucionais, landing pages de alta conversão, hotsites para campanhas publicitárias e grandes portais.<br/>Foi nesse ambiente dinâmico que a paixão pela codificação despertou, transformando o design estático em experiências interativas.',
        whoIAmP3:
          'Me especializei em dar vida às interfaces utilizando o ecossistema do <strong>JavaScript</strong> e tecnologias modernas do lado do cliente, garantindo que cada pixel interaja perfeitamente com o usuário.',
        experiencesTitle: 'Experiências comprovadas de alto impacto',
        experienceAliensDesign:
          '<a href="https://aliensdesign.com.br/" rel="noopener" target="_blank">Aliens Design</a>: Agência de publicidade em Curitiba, com uma equipe dinâmica e comprometida com resultados.<br/>Pude colaborar em projetos desafiadores de ponta-a-ponta, entregando alto valor técnico e estético para marcas de diversos segmentos.',
        experienceSabion:
          '<a href="https://www.instagram.com/sabion_digital/" rel="noopener" target="_blank">Sabion Digital</a>: Atuei de forma híbrida e estratégica, entregando soluções como <strong>UI Designer</strong> diretamente para a <strong>Bradesco Seguros</strong>, e como Desenvolvedor Front-end nos projetos internos da agência.',
        experienceObjective:
          '<a href="https://www.objective.com.br" rel="noopener" target="_blank">Objective Solutions</a>: Atuei como <strong>analista frontend</strong>, alocado diretamente no cliente <strong>Bank of America</strong>. Nessa experiência de alta escala, integrei um time multidisciplinar de alta performance focado na evolução do sistema interno do banco.',
        whatIBringTitle: 'O que eu trago para seu projeto',
        whatIBringP1:
          '<strong>Visão Híbrida (Design + Código)</strong>: Capacidade única de entender a fundo a experiência do usuário (UI/UX) e traduzi-la perfeitamente em código limpo, sem perda de fidelidade visual.',
        whatIBringP2:
          '<strong>Foco em Performance</strong>: Criação de plataformas, aplicações e landing pages focadas em velocidade, acessibilidade e interações fluidas.',
        whatIBringP3:
          '<strong>Adaptação e Evolução</strong>: Histórico comprovado de modernização de sistemas antigos para as tecnologias web mais recentes do mercado.',
        cta: 'E então, qual seu próximo projeto?',
      },
    },
    'en-us': {
      nav: {
        work: 'Projects',
        about: 'About',
        contact: 'Contact',
      },
      mainTitle:
        'Creating modern, responsive, and accessible interfaces, focused on the best user experience.',
      imageDescriptionLeft:
        'Background image of Julio Graffin wearing prescription glasses.',
      imageDescriptionRight: 'Background image of a generic source-code.',
      headingProjects:
        'Institutional websites, landing pages, hotsites, hybrid applications, and digital portals. Experience working in different environments and teams, where I developed a mindset <strong>focused on continuous improvement</strong>.',
      descriptionProjects:
        '<strong>With more than 12 years of experience</strong> working at various technology companies around the world, I have solid expertise focused on usability, accessibility, and the development of high-quality digital products.',
      seeMore: 'see more',
      seeProject: 'see project',
      send: 'send',
      sending: 'Sending...',
      form: {
        name: 'Name',
        email: 'Email',
        message: 'Message',
        required: '(Required)',
        placeholder: 'Type your message here...',
        contactForm: 'Contact Form',
        contactChannels: 'Contact channels and Social Media',
        errorName: 'Please enter your full name.',
        errorEmail: 'Please enter a valid email address.',
        errorMessage: 'Message must be at least 10 characters.',
        successMessage:
          'Message sent successfully! I will get back to you soon.',
        errorSend: 'Could not send your message. Please try again.',
      },
      about: {
        pageTitle: 'Julio Cezar Ferreira',
        pageSubtitle: 'Senior Frontend Developer Analyst',
        whoIAmTitle: 'About Me',
        whoIAmP1:
          'With a solid background in the technology industry since 2010, my career has been shaped by the combination of <strong>visual design</strong> and <strong>code precision</strong>.',
        whoIAmP2:
          'I started my journey as a <strong>Web Designer</strong> at the agency <strong>Refinaria Ilimitada</strong>, where I created institutional layouts, high-conversion landing pages, hotsites for advertising campaigns, and large web portals.<br/>It was in that dynamic environment that my passion for coding was ignited, transforming static design into interactive experiences.',
        whoIAmP3:
          'I specialised in bringing interfaces to life using the <strong>JavaScript</strong> ecosystem and modern client-side technologies, ensuring every pixel interacts seamlessly with the user.',
        experiencesTitle: 'Proven high-impact experiences',
        experienceAliensDesign:
          '<a href="https://aliensdesign.com.br/" rel="noopener" target="_blank">Aliens Design</a>: An advertising agency in Curitiba, with a dynamic team committed to delivering results.<br/>I collaborated on challenging end-to-end projects, delivering high technical and aesthetic value for brands across various industries.',
        experienceSabion:
          '<a href="https://www.instagram.com/sabion_digital/" rel="noopener" target="_blank">Sabion Digital</a>: I worked in a hybrid and strategic role, delivering solutions as a <strong>UI Designer</strong> directly for <strong>Bradesco Seguros</strong>, and as a Frontend Developer on the agency\'s internal projects.',
        experienceObjective:
          '<a href="https://www.objective.com.br" rel="noopener" target="_blank">Objective Solutions</a>: I worked as a <strong>frontend analyst</strong>, embedded directly at the client <strong>Bank of America</strong>. In this high-scale engagement, I joined a high-performance multidisciplinary team focused on evolving the bank\'s internal systems.',
        whatIBringTitle: 'What I bring to your project',
        whatIBringP1:
          '<strong>Hybrid Vision (Design + Code)</strong>: A unique ability to deeply understand the user experience (UI/UX) and translate it precisely into clean code, with no loss of visual fidelity.',
        whatIBringP2:
          '<strong>Performance Focus</strong>: Building platforms, applications, and landing pages optimised for speed, accessibility, and smooth interactions.',
        whatIBringP3:
          '<strong>Adaptability and Growth</strong>: A proven track record of modernising legacy systems to the latest web technologies on the market.',
        cta: "So, what's your next project?",
      },
    },
    'es-es': {
      nav: {
        work: 'Proyectos',
        about: 'Sobre mí',
        contact: 'Contacto',
      },
      mainTitle:
        'Creando interfaces modernas, responsivas y accesibles, enfocadas en la mejor experiencia de usuario.',
      imageDescriptionLeft:
        'Fondo con la imagen del rostro de Julio Graffin usando gafas graduadas.',
      imageDescriptionRight:
        'Fondo con la imagen de un código fuente genérico.',
      headingProjects:
        'Sitios web institucionales, landing pages, micrositios, aplicaciones híbridas y portales digitales. Experiencia en distintos entornos y equipos, donde desarrollé una visión <strong>enfocada en la mejora continua</strong>.',
      descriptionProjects:
        '<strong>Con más de 12 años de experiencia</strong> trabajando en diversas empresas de tecnología alrededor del mundo, cuento con sólidos conocimientos enfocados en la usabilidad, la accesibilidad y el desarrollo de productos digitales de alta calidad.',
      seeMore: 'ver más',
      seeProject: 'ver proyecto',
      send: 'enviar',
      sending: 'Enviando...',
      form: {
        name: 'Nombre',
        email: 'Correo electrónico',
        message: 'Mensaje',
        required: '(Obligatorio)',
        placeholder: 'Escribe tu mensaje aquí...',
        contactForm: 'Formulario de contacto',
        contactChannels: 'Canales de atención y Redes Sociales',
        errorName: 'Por favor, ingresa tu nombre completo.',
        errorEmail: 'Por favor, ingresa un correo electrónico válido.',
        errorMessage: 'El mensaje debe tener al menos 10 caracteres.',
        successMessage:
          '¡Mensaje enviado con éxito! Me pondré en contacto contigo pronto.',
        errorSend:
          'No se pudo enviar el mensaje. Por favor, inténtalo de nuevo.',
      },
      about: {
        pageTitle: 'Julio Cezar Ferreira',
        pageSubtitle: 'Analista Desarrollador Frontend Sr.',
        whoIAmTitle: 'Sobre mí',
        whoIAmP1:
          'Con una trayectoria sólida en el mundo de la tecnología desde 2010, mi carrera se caracteriza por la unión entre el <strong>diseño visual</strong> y la <strong>precisión del código</strong>.',
        whoIAmP2:
          'Comencé mi camino como <strong>Web Designer</strong> en la agencia <strong>Refinaria Ilimitada</strong>, donde creé layouts institucionales, landing pages de alta conversión, hotsites para campañas publicitarias y grandes portales web.<br/>Fue en ese entorno dinámico donde nació mi pasión por la programación, transformando el diseño estático en experiencias interactivas.',
        whoIAmP3:
          'Me especialicé en dar vida a las interfaces utilizando el ecosistema de <strong>JavaScript</strong> y tecnologías modernas del lado del cliente, garantizando que cada píxel interactúe perfectamente con el usuario.',
        experiencesTitle: 'Experiencias comprobadas de alto impacto',
        experienceAliensDesign:
          '<a href="https://aliensdesign.com.br/" rel="noopener" target="_blank">Aliens Design</a>: Agencia de publicidad en Curitiba, con un equipo dinámico y comprometido con los resultados.<br/>Pude colaborar en proyectos desafiantes de principio a fin, aportando alto valor técnico y estético a marcas de distintos sectores.',
        experienceSabion:
          '<a href="https://www.instagram.com/sabion_digital/" rel="noopener" target="_blank">Sabion Digital</a>: Trabajé de forma híbrida y estratégica, entregando soluciones como <strong>UI Designer</strong> directamente para <strong>Bradesco Seguros</strong>, y como Desarrollador Frontend en los proyectos internos de la agencia.',
        experienceObjective:
          '<a href="https://www.objective.com.br" rel="noopener" target="_blank">Objective Solutions</a>: Me desempeñé como <strong>analista frontend</strong>, asignado directamente al cliente <strong>Bank of America</strong>. En esta experiencia de gran escala, formé parte de un equipo multidisciplinario de alto rendimiento enfocado en la evolución del sistema interno del banco.',
        whatIBringTitle: 'Lo que aporto a tu proyecto',
        whatIBringP1:
          '<strong>Visión Híbrida (Diseño + Código)</strong>: Capacidad única de comprender en profundidad la experiencia del usuario (UI/UX) y traducirla con precisión en código limpio, sin pérdida de fidelidad visual.',
        whatIBringP2:
          '<strong>Enfoque en Performance</strong>: Creación de plataformas, aplicaciones y landing pages orientadas a la velocidad, accesibilidad e interacciones fluidas.',
        whatIBringP3:
          '<strong>Adaptación y Evolución</strong>: Historial comprobado de modernización de sistemas heredados hacia las tecnologías web más recientes del mercado.',
        cta: '¿Y bien, cuál es tu próximo proyecto?',
      },
    },
  },
};
